<template>
  <div class="app-container">
    <iframe :src="iframeUrl"></iframe>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Cookie from 'js-cookie'

import * as utils from '@/utils'

export default {
  components: {},
  data() {
    return {
      iframeUrl: 'https://bi.wlines.cn/webroot/decision/link/y8Y0', // 线上的
      // iframeUrl: 'https://bi.wlines.cn/webroot/decision/link/lPXM'  // 247
    }
  },

  created() {},

  mounted() {},

  beforeDestroy() {},

  methods: {},
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.app-container {
  padding: 0;
  iframe {
    width: 100%;
    height: 100%;
    vertical-align: top;
    border: none;
  }
}
</style>